import $ from '../jquery-shim.js';

export function generateTopbarSlider() {
  var $slider = $('.usp-topbar-slider');
  var $slides = $slider.children();
  var current = 0;

  function showSlide(index) {
    $slides.hide().eq(index).slideDown();
  }

  setInterval(function() {
    current = (current + 1) % $slides.length;
    showSlide(current);
  }, 2500);



  let desktopInterval;
  let currentDesktop = 0;
  const $desktopSlider = $('.usp-topbar-slider-desktop');
  const $desktopSlides = $desktopSlider.children().not('.header-divider');

  function showDesktopSlide(index) {
    $desktopSlides.hide().eq(index).slideDown();
  }

  function startSlider() {
    if (!desktopInterval) { // only start if not already running
      currentDesktop = 0; // reset index when restarting
      showDesktopSlide(currentDesktop);
      desktopInterval = setInterval(function () {
        currentDesktop = (currentDesktop + 1) % $desktopSlides.length;
        showDesktopSlide(currentDesktop);
      }, 2500);
    }
  }

  function stopSlider() {
    if (desktopInterval) {
      clearInterval(desktopInterval);
      desktopInterval = null;
    }
    $desktopSlides.show(); // reset: all slides visible again
  }

  function checkSlider() {
    if (window.innerWidth < 1200) {
      startSlider();
    } else {
      stopSlider();
    }
  }

  // run once on load
  checkSlider();

  // re-check on resize
  $(window).on('resize', checkSlider);
}


